import { HttpClient} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { UrlServidor } from '../util/url-servidor';
import { IndicadorCliente } from '../api/dto/indicador-cliente';
import { Anamnese } from '../api/dto/anamnese';

@Injectable({
    providedIn: 'root',
})
export class AnamneseService {

    constructor(private http: HttpClient) { }
    private url: string = UrlServidor.URL_BASE + 'anamneses-clientes/';

    buscarPorId(id?: number): Observable<IndicadorCliente> {
        return this.http.get<IndicadorCliente>(this.url + id);
    }

    listarPorEmpresa(empresaId?: number): Observable<Anamnese[]> {
        return this.http.get<Anamnese[]>(this.url + 'empresa/' + empresaId);
    }

    salvar(anamnese: Anamnese): Observable<Anamnese> {
        return this.http.post<Anamnese>(this.url, anamnese);
    }

    atualizar(id?: number, anamnese?: Anamnese): Observable<Anamnese> {
        return this.http.put<Anamnese>(this.url + id, anamnese);
    }

    excluir(id?: number): Observable<void> {
        return this.http.delete<void>(this.url + id);
    }
}